import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Grid, Stack } from '@mui/material';
import SpeakersCards from './Components/SpeakersCards';
import { GoPlus } from 'react-icons/go';
import NoData from '../../../../../../components/Common/NoData';
import { LanguageContext } from '../../../../../../libs/Context';
import AddSpeaker from './Components/AddSpeaker';
import { getSpeakersList } from '../../../../../actions/meeting_actions';
import useInterSectionObserver from '../../../../../../libs/CustomHooks/useIntersectionObserver';
import { toast } from 'react-toastify';

const Speakers = (props) =>
{
	const { form, handleBackCallBack, handleSkipFinish,
		handleNextCallBack, handleDeletePop } = props;
	const { language } = useContext(LanguageContext);
	const [ addSpeakers, setAddSpeakers ] = useState({
		open              : false,
		selEditSpeakDetls : {}
	});
	const [ speakerList, setSpeakerList ] = useState<any>([]);
	const [ count, setCount ] = useState(0);
	const [ page, setPage ] = useState(0);
	const loaderRef = useRef<any>();
	const lastEleRef = useRef<HTMLDivElement | null>(null);
	const [ delGetApi, setDelGetApi ] = useState(false);
	const itemPerPage = 10;

	const LoadMoreList = useInterSectionObserver({
		lastEleRef, loaderRef, count, data : speakerList, setPage
	});

	const handleAddSpeaker = (e, data) =>
	{
		setAddSpeakers({
			open              : true,
			selEditSpeakDetls : data
		});
	};

	const getHostCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const res = await getSpeakersList(query);

			if (res?.status)
			{
				setCount(res?.count);
			}
			else
			{
				setCount(0);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.error('Error fetching host count:', err);
			setCount(0);
		}
	};

	const fetchSpeakersList = async () =>
	{
		const query = {
			sessionId : form?.id,
			limit     : itemPerPage,
			skip      : 0

		};

		try
		{
			const res = await getSpeakersList(query);

			if (res?.status)
			{
				if (page === 0)
				{
					setSpeakerList(res?.data);
				}
				else
				{
					setSpeakerList((prev:any) => ([ ...prev, ...(res?.data || []) ]));
				}

				if (res?.data?.length >= itemPerPage)
				{
					getHostCount(query);
				}
				else
				{
					setCount(res?.data?.length);
				}
				loaderRef.current = false;
			}
			else
			{
				loaderRef.current = false;
			}
		}
		catch (error:any)
		{
			// eslint-disable-next-line no-console
			console.log('err', error);
			toast.error(error?.response?.data?.message, {
				position : toast.POSITION.TOP_RIGHT
			});
			loaderRef.current = false;
		}
	};

	const handleCloseSpeakerPopup = (status = false) =>
	{
		setAddSpeakers({
			open              : false,
			selEditSpeakDetls : {}
		});

		if (status)
		{
			fetchSpeakersList();
		}
	};

	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, count, speakerList ]);

	useEffect(() =>
	{
		fetchSpeakersList();
	}, [ page, delGetApi ]);

	return (

		<>
			<Stack direction='column' height='calc(100% - 56px)'>
				{speakerList?.length > 0 &&
				<Stack
					direction='row'
					spacing={0.5}
					alignItems='center'
					justifyContent={'end'}
					width={'var(--percent100)'}
					sx={{ cursor: 'pointer' }}
					onClick={(e) => handleAddSpeaker(e, {})}
				>
					<Button
						variant='outlined'
						startIcon={<GoPlus fontSize='var(--pixel18)' />}
					>
						{language?.addspeaker}
					</Button>
				</Stack>
				}
				<Grid container px='var(--pixel8)' py='6px' spacing={1.5} height={speakerList?.length > 0 ? '' : 'var(--percent100)'} alignItems={speakerList?.length > 0 ? '' : 'center'} justifyContent={speakerList?.length > 0 ? '' : 'center'}>
					{speakerList?.length > 0
						? speakerList?.map((each:any, index:any) => (
							<>
								<SpeakersCards
									handleAddSpeaker={handleAddSpeaker}
									item={each} key={each?._id}
									setDelGetApi={setDelGetApi}
								/>
								{(index === speakerList?.length - 2) && <span ref={lastEleRef}/>}
							</>

						))
						: <Stack direction='column' alignItems='center' height='var(--percent100)' justifyContent='center'>
							<NoData noDataHead={language?.NoSpeakerAdd}
								src1={'/images/icons/webSpeakers.svg'}
							/>
							<Button color='primary' variant='outlined' onClick={(e) => handleAddSpeaker(e, {})}>{language?.add}</Button>
						</Stack>

					}
				</Grid>
			</Stack>
			<Grid
				container
				justifyContent={'space-between'}
				alignItems='center'
				p='var(--pixel16)'
			>
				<Stack
					direction='row'
					alignItems='center'
					spacing={1}
				>
					<Button
						variant='outlined'
						onClick={handleBackCallBack}
					>
						{language?.previous}
					</Button>
					<Button onClick={handleSkipFinish} variant='outlined'>
						{language?.skipandFinish}
					</Button>
				</Stack>
				<Grid item>
					<Stack direction='row' spacing={1}>
						<Button
							onClick={handleDeletePop}
							variant='outlined'
						>
							{language?.cancel}
						</Button>
						<Button
							variant='contained'
							sx={{ color: 'var(--whiteColor)' }}
							onClick={handleNextCallBack}
						>
							{language?.next}
						</Button>
					</Stack>
				</Grid>
			</Grid>
			{addSpeakers?.open && (
				<AddSpeaker
					open={addSpeakers?.open}
					handleSpeakerClose={handleCloseSpeakerPopup}
					setSpeakers={setAddSpeakers}
					selSpeakDetails={addSpeakers?.selEditSpeakDetls}
					form={form}
				/>
			)}
		</>

	);
};

export default Speakers;
